import { useEventPowerDialerCreated } from 'entities/PowerDialer/events/EventPowerDialerCreated'
import { useEventPowerDialerUpdated } from 'entities/PowerDialer/events/EventPowerDialerUpdated'
import { type PowerDialerListStore } from 'pages/powerDialer/pages/list/store/PowerDialerListStore'

export const useEventListPowerDialerUpdated = (store: PowerDialerListStore) => {
  const { resetPageAndFilters, updateListItem } = store

  useEventPowerDialerCreated(() => {
    resetPageAndFilters()
  })

  useEventPowerDialerUpdated((powerDialerResponse) => {
    updateListItem(powerDialerResponse)
  })
}
